import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { set_value_toolbox, toolbox_handle_routing_mapbox } from '../../App/actions/toolboxActions';
import { get_transportation_profiles } from '../../App/validation/transportation_profiles';
import { Reorder, useDragControls } from 'framer-motion';
import icon_hamburger from "../../Assets/svg/icon_hamburger.svg";
import { format_time } from '../../App/validation/count_day_left';
import ICON_CLOSE from '../../Assets/jsx/ICON_CLOSE';
import { featureCollection } from "@turf/helpers";
import useLanguage from '../common_hooks/useLanguage';

const profiles = get_transportation_profiles();

function SETTING_ROUTING() {
  const toolbox = useSelector((state) => (state.toolbox)) || {};
  const { name_toolbox, routing_profile, features_routing_obj, routing_active_uuid } = toolbox;
  const [is_dragging, set_is_dragging] = useState(false);

  const { map_object } = useSelector((state) => (state.layer)) || {};
  // const selected_row_toolbox_ids = toolbox[uuid_name];
  const destination_feature = useMemo(() => {
    return features_routing_obj?.data?.[routing_active_uuid]?.point || [];
  }, [features_routing_obj, routing_active_uuid]);
  const current_feature = features_routing_obj?.data?.[routing_active_uuid]?.lineString;

  const source_id_point = `geojson_routing_point`
  const source_id_line = `geojson_routing_line`

  const dispatch = useDispatch();
  const { dict, language } = useLanguage();

  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    if (!destination_feature) return;

    setDestinations((prev) => {
      const isSame =
        prev.length === destination_feature.length &&
        prev.every(
          (d, i) =>
            d.properties.uuid === destination_feature[i]?.properties?.uuid &&
            d.properties.name === destination_feature[i]?.properties?.name
        );

      return isSame ? prev : destination_feature;
    });
  }, [destination_feature]);


  const change_profile = async (value) => {
    if (!profiles?.[value]) return;
    dispatch(set_value_toolbox({
      key: "routing_profile",
      value: value
    }))


    if (features_routing_obj?.data?.[routing_active_uuid]?.points?.length < 2) {

      const new_features_line = [];
      const new_features_point = [];
      features_routing_obj.order.forEach(uuid => {
        new_features_line.push(features_routing_obj?.data?.[uuid]?.lineString);
        new_features_point.push(...features_routing_obj?.data?.[uuid]?.point);
      })

      if (!map_object) return;

      if (map_object?.getSource(source_id_line))
        map_object.getSource(source_id_line)?.setData(
          featureCollection(new_features_line)
        );

      if (map_object?.getSource(source_id_point))
        map_object.getSource(source_id_point)?.setData(
          featureCollection(new_features_point)
        );

    } else {
      await dispatch(toolbox_handle_routing_mapbox());
    }
  }

  const remove_point = async (uuid) => {

    const lineString = features_routing_obj?.data?.[routing_active_uuid]?.lineString;
    const new_points = features_routing_obj?.data?.[routing_active_uuid]?.point?.filter((item) =>
      item?.properties?.uuid !== uuid
    )

    const new_features_routing_obj = {
      ...features_routing_obj,
      data: {
        ...features_routing_obj?.data,
        [routing_active_uuid]: {
          ...features_routing_obj?.data?.[routing_active_uuid],
          point: new_points,
          lineString: new_points?.length < 2 ? null : lineString
        }
      }
    }

    dispatch(
      set_value_toolbox({
        key: "features_routing_obj",
        value: new_features_routing_obj
      })
    )

    if (new_points?.length < 2) {

      const new_features_line = [];
      new_features_routing_obj.order.filter(uuid => uuid !== routing_active_uuid).forEach(uuid => {
        new_features_line.push(features_routing_obj?.data?.[uuid]?.lineString);
      })

      if (!map_object) return;

      if (map_object?.getSource(source_id_line))
        map_object.getSource(source_id_line)?.setData(
          featureCollection(new_features_line)
        );

      if (map_object?.getSource(source_id_point))
        map_object.getSource(source_id_point)?.setData(
          featureCollection(new_points)
        );

    } else {
      await dispatch(toolbox_handle_routing_mapbox());
    }
  }

  const submit_reorder_destination = async () => {
    dispatch(
      set_value_toolbox({
        key: "features_routing_obj",
        value: {
          ...features_routing_obj,
          data: {
            ...features_routing_obj?.data,
            [routing_active_uuid]: {
              ...features_routing_obj?.data?.[routing_active_uuid],
              point: destinations
            }
          }
        }
      })
    )

    await dispatch(toolbox_handle_routing_mapbox())
  }

  let estimated_arrival = "-";
  if (current_feature?.properties?.duration_sec) {
    if (language === "eng") estimated_arrival = format_time(current_feature?.properties?.duration_sec, language);
    else estimated_arrival = format_time(current_feature?.properties?.duration_sec, language);
  } else estimated_arrival = "-";

  return (
    <div
      style={{
        width: "230px",
        // width: "360px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        margin: "10px 0 10px 0",
      }}
    >
      {name_toolbox &&
        <section
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "19px",
              color: "#000000",
            }}
          >
            {language === "ina" && `${dict["Setting"][language]} `}
            {`${name_toolbox}`}
            {language === "eng" && ` ${dict["Setting"][language]}`}
          </div>

          {/* {selected_row_toolbox_ids?.length > 0 &&  */}
          {current_feature?.properties?.id_tool && <div
            style={{
              fontSize: "12px",
              color: "#000000",
            }}
          >
            {`${current_feature?.properties?.id_tool} ${dict["Selected"][language]}`}
          </div>}
          {/* } */}
        </section>
      }

      <hr />

      <section
        className="no-drag"
        style={{
          cursor: "default",
          padding: "6px 8px",
          marginBottom: "15px",
          borderRadius: "15px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
        onMouseUp={async () => {
          if (is_dragging) {
            submit_reorder_destination();
            set_is_dragging(false);
          }
        }}
      >
        <p style={{ fontSize: "14px" }}>{dict["Destination"][language]}</p>
        <Reorder.Group
          style={{ flexDirection: "column", display: "flex", gap: "5px" }}
          axis="y"
          values={destinations}
          onReorder={setDestinations}
        >
          {
            destinations.map((feature, idx) => (
              <DestinationItem
                isLast={idx === destinations?.length - 1}
                index={idx}
                key={feature.properties.uuid}
                feature={feature}
                is_dragging={is_dragging}
                set_is_dragging={set_is_dragging}
                remove_point={remove_point}
              />
            ))
          }
        </Reorder.Group>
        {
          destination_feature?.length === 10 && <p
            style={{
              border: "1px solid #D3B572",
              backgroundColor: "#FFFAEC",
              padding: "8px 16px",
              borderRadius: "20px",
              fontSize: "12px",
              color: "#6C5D3A",
            }}
          >
            You have reached the maximum number of destinations (10).
          </p>
        }
      </section >

      <section style={{ display: "flex", flexDirection: "column", gap: "15px", marginBottom: "20px", padding: "6px 8px", }}>
        <span style={{ fontSize: "14px" }}>{dict["Transportation Mode"][language]}</span>
        <div style={{ display: "flex", gap: "5px", justifyContent: "space-around" }}>
          {
            Object.keys(profiles).map(key => (
              <div
                key={key}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  gap: "5px"
                }}
              >
                <button
                  onClick={() => change_profile(key)}
                  disabled={!profiles[key]?.mapbox}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "100%",
                    width: "50px",
                    height: "50px",
                    border: "1px solid",
                    backgroundColor: routing_profile === key ? "black" : !profiles[key]?.mapbox ? "#ABABAB80" : "white"
                  }}>
                  <img
                    alt={profiles[key].name}
                    src={profiles[key].icon}
                    style={{
                      width: "30px",
                      height: "30px",
                      filter: routing_profile === key || !profiles[key]?.mapbox ? "invert(0%)" : "invert(100%)",
                      // backgroundColor: routing_profile === key ? "black" : "white"
                    }}
                  />
                </button>
                <label style={{ cursor: "pointer", color: !profiles[key]?.mapbox ? "#ABABAB80" : "black" }}>{dict[profiles[key].name][language]}</label>
              </div>
            ))
          }

        </div>
      </section>

      <section>
        <p style={{ fontSize: "14px", padding: "6px 8px", }}>{dict["Estimated arrival"][language]}: {estimated_arrival}</p>
      </section>
    </div >

  )
}

function DestinationItem({ feature, is_dragging, set_is_dragging, index, isLast, remove_point }) {
  const dragControls = useDragControls();

  const numberToAlphabet = (num) => {
    if (num <= 0) return '';
    return numberToAlphabet(Math.floor((num - 1) / 26)) + String.fromCharCode((num - 1) % 26 + 65);
  };

  const delete_destination = (uuid) => {
    remove_point(uuid);
  }


  return (
    <div style={{ position: "relative" }}>
      {/* Garis putus-putus vertikal — tampil di semua item kecuali yang terakhir */}
      {!isLast && (
        <div style={{
          position: "absolute",
          left: "42px", // sesuaikan dengan posisi tengah lingkaran
          top: "18px",  // mulai dari bawah lingkaran
          bottom: "-10px",
          borderLeft: "2px dashed #ABABAB",
          zIndex: 0,
        }} />
      )}

      <Reorder.Item
        key={feature.properties.uuid}
        value={feature}
        dragListener={false}
        dragControls={dragControls}
        style={{ display: "flex", alignItems: "center", gap: "5px", position: "relative", zIndex: 1, marginLeft: 0 }}
      >
        <div
          style={{ cursor: is_dragging ? "grabbing" : "grab", marginRight: "10px" }}
          onPointerDown={(event) => {
            set_is_dragging(true);
            dragControls.start(event);
          }}
        >
          <img alt="draggable" draggable={false} src={icon_hamburger} style={{ width: 20, height: 20 }} />
        </div>

        <div style={{
          border: "1px solid black",
          borderRadius: "100%",
          width: "15px",
          height: "15px",
          fontSize: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
        }}>
          {numberToAlphabet(index + 1)}
        </div>

        <div style={{
          border: "1px solid #ABABAB80",
          borderRadius: "5px",
          padding: "0 5px",
          fontSize: "12px",
          width: "60%",
          overflowX: "auto"
        }}
        >
          {feature.properties.name}
        </div>

        <button
          onClick={() => delete_destination(feature.properties.uuid)}
          style={{ cursor: "pointer", backgroundColor: "red", borderRadius: "100%", width: "18px", height: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <ICON_CLOSE color="red" />
        </button>
      </Reorder.Item>
    </div>
  );
}

export default SETTING_ROUTING